// extracted by mini-css-extract-plugin
module.exports = {"Card":"Modal_Card__3VhC5","Media":"Modal_Media__2jdVl","Paper":"Modal_Paper__3xSQ9"};